import React from 'react';
import { Card } from "react-bootstrap";
import styles from '../SessionHistoryDetailView.module.css';

const MedicalConcernsSection = ({
  sessionFormData,
  updateFormData,
  handleMedicalConditionChange,
  handlePastPsychiatricChange,
  handleFamilyPsychiatricChange,
  medicalConditionsError,
  autoResizeTextarea
}) => {
  const medicalConditionsLeft = ["None", "Asthma", "Cancer", "Diabetes", "Other"];
  const medicalConditionsRight = ["Heart Disease", "Hypertension", "Chronic Pain", "Thyroid Disorder", "Allergies"];
  const pastPsychiatricLeft = ["None", "Inpatient", "Other"];
  const pastPsychiatricRight = ["Outpatient", "ER Visit(s)", "Medication Management"];
  const familyPsychiatricLeft = ["None", "Depression", "Anxiety", "Other"];
  const familyPsychiatricRight = ["Bipolar Disorder", "Substance Use Disorder", "Schizophrenia", "Suicide Attempt"];

  return (
    <Card id="medical-psychiatric" className={styles.card}>
      <h3 className={styles.sectionHeading}>
        Medical & Psychiatric History
      </h3>

      <div style={{ marginBottom: "24px" }}>
        <label className={styles.labelWithMarginLarge}>
          Medical Conditions
        </label>

        {medicalConditionsError && (
          <div className={styles.errorMessage} style={{ marginTop: "8px", color: "red", fontSize: "14px" }}>
            {medicalConditionsError}
          </div>
        )}
        <div className={styles.checkboxRow}>
          <div className={styles.checkboxColumn}>
            {medicalConditionsLeft.map((item) => {
              const isNoneSelected = sessionFormData.selectedMedicalConditions.includes("None");
              const isDisabled = isNoneSelected && item !== "None";
              return (
                <div key={item} className={styles.checkboxContainer}>
                  <input
                    type="checkbox"
                    id={`medical-${item}`}
                    checked={sessionFormData.selectedMedicalConditions.includes(item)}
                    onChange={() => handleMedicalConditionChange(item)}
                    disabled={isDisabled}
                    className={styles.checkbox}
                  />
                  <label
                    htmlFor={`medical-${item}`}
                    className={styles.checkboxLabel}
                    style={isDisabled ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                  >
                    {item}
                  </label>
                </div>
              );
            })}
          </div>
          <div className={styles.checkboxColumn}>
            {medicalConditionsRight.map((item) => {
              const isNoneSelected = sessionFormData.selectedMedicalConditions.includes("None");
              const isDisabled = isNoneSelected && item !== "None";
              return (
                <div key={item} className={styles.checkboxContainer}>
                  <input
                    type="checkbox"
                    id={`medical-${item}`}
                    checked={sessionFormData.selectedMedicalConditions.includes(item)}
                    onChange={() => handleMedicalConditionChange(item)}
                    disabled={isDisabled}
                    className={styles.checkbox}
                  />
                  <label
                    htmlFor={`medical-${item}`}
                    className={styles.checkboxLabel}
                    style={isDisabled ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                  >
                    {item}
                  </label>
                </div>
              );
            })}
          </div>
        </div>

        {sessionFormData.selectedMedicalConditions.includes("Other") && (
          <div style={{ marginTop: "12px" }}>
            <textarea
              id="medical-other-textarea"
              value={sessionFormData.otherMedicalConditionText || ""}
              onChange={(e) => {
                autoResizeTextarea(e.target);
                updateFormData("otherMedicalConditionText", e.target.value);
              }}
              placeholder="Please specify."
              className={styles.otherTextInput}
              rows={1}
              style={{ minHeight: "34px", resize: "none", overflow: "hidden" }}
            />
          </div>
        )}
      </div>

      <div style={{ marginBottom: "24px" }}>
        <label className={styles.labelWithMarginLarge}>
          Past Psychiatric Treatment
        </label>
        <div className={styles.checkboxRow}>
          <div className={styles.checkboxColumn}>
            {pastPsychiatricLeft.map((item) => {
              const isNoneSelected = sessionFormData.selectedPastPsychiatric.includes("None");
              const isDisabled = isNoneSelected && item !== "None";
              return (
                <div key={item} className={styles.checkboxContainer}>
                  <input
                    type="checkbox"
                    id={`past-psychiatric-${item}`}
                    checked={sessionFormData.selectedPastPsychiatric.includes(item)}
                    onChange={() => handlePastPsychiatricChange(item)}
                    disabled={isDisabled}
                    className={styles.checkbox}
                  />
                  <label
                    htmlFor={`past-psychiatric-${item}`}
                    className={styles.checkboxLabel}
                    style={isDisabled ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                  >
                    {item}
                  </label>
                </div>
              );
            })}
          </div>
          <div className={styles.checkboxColumn}>
            {pastPsychiatricRight.map((item) => {
              const isNoneSelected = sessionFormData.selectedPastPsychiatric.includes("None");
              const isDisabled = isNoneSelected && item !== "None";
              return (
                <div key={item} className={styles.checkboxContainer}>
                  <input
                    type="checkbox"
                    id={`past-psychiatric-${item}`}
                    checked={sessionFormData.selectedPastPsychiatric.includes(item)}
                    onChange={() => handlePastPsychiatricChange(item)}
                    disabled={isDisabled}
                    className={styles.checkbox}
                  />
                  <label
                    htmlFor={`past-psychiatric-${item}`}
                    className={styles.checkboxLabel}
                    style={isDisabled ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                  >
                    {item}
                  </label>
                </div>
              );
            })}
          </div>
        </div>
        {sessionFormData.selectedPastPsychiatric.includes("Other") && (
          <div style={{ marginTop: "12px" }}>
            <textarea
              id="past-psychiatric-other-textarea"
              value={sessionFormData.otherPastPsychiatricText || ""}
              onChange={(e) => {
                autoResizeTextarea(e.target);
                updateFormData("otherPastPsychiatricText", e.target.value);
              }}
              placeholder="Please specify."
              className={styles.otherTextInput}
              rows={1}
              style={{ minHeight: "34px", resize: "none", overflow: "hidden" }}
            />
          </div>
        )}
      </div>

      <div style={{ marginBottom: "24px" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <label className={styles.labelWithMargin}>
            Current Medications
          </label>
          <div style={{ marginTop: "4px", fontSize: "12px", color: "#8E8E93" }}>
            {sessionFormData.currentMedications?.length || 0}/400
          </div>
        </div>
        <textarea
          value={sessionFormData.currentMedications}
          onChange={(e) => {
            const value = e.target.value;
            if (value.length <= 400) {
              updateFormData("currentMedications", value);
            }
          }}
          placeholder="Free Text"
          className={styles.textarea}
          maxLength={400}
        />
      </div>

      <div>
        <label className={styles.labelWithMarginLarge}>
          Family Psychiatric History
        </label>
        <div className={styles.checkboxRow}>
          <div className={styles.checkboxColumn}>
            {familyPsychiatricLeft.map((item) => {
              const isNoneSelected = sessionFormData.selectedFamilyPsychiatric.includes("None");
              const isDisabled = isNoneSelected && item !== "None";
              return (
                <div key={item} className={styles.checkboxContainer}>
                  <input
                    type="checkbox"
                    id={`family-psychiatric-${item}`}
                    checked={sessionFormData.selectedFamilyPsychiatric.includes(item)}
                    onChange={() => handleFamilyPsychiatricChange(item)}
                    disabled={isDisabled}
                    className={styles.checkbox}
                  />
                  <label
                    htmlFor={`family-psychiatric-${item}`}
                    className={styles.checkboxLabel}
                    style={isDisabled ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                  >
                    {item}
                  </label>
                </div>
              );
            })}
          </div>
          <div className={styles.checkboxColumn}>
            {familyPsychiatricRight.map((item) => {
              const isNoneSelected = sessionFormData.selectedFamilyPsychiatric.includes("None");
              const isDisabled = isNoneSelected && item !== "None";
              return (
                <div key={item} className={styles.checkboxContainer}>
                  <input
                    type="checkbox"
                    id={`family-psychiatric-${item}`}
                    checked={sessionFormData.selectedFamilyPsychiatric.includes(item)}
                    onChange={() => handleFamilyPsychiatricChange(item)}
                    disabled={isDisabled}
                    className={styles.checkbox}
                  />
                  <label
                    htmlFor={`family-psychiatric-${item}`}
                    className={styles.checkboxLabel}
                    style={isDisabled ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                  >
                    {item}
                  </label>
                </div>
              );
            })}
          </div>
        </div>
        {sessionFormData.selectedFamilyPsychiatric.includes("Other") && (
          <div style={{ marginTop: "12px" }}>
            <textarea
              id="family-psychiatric-other-textarea"
              value={sessionFormData.otherFamilyPsychiatricText || ""}
              onChange={(e) => {
                autoResizeTextarea(e.target);
                updateFormData("otherFamilyPsychiatricText", e.target.value);
              }}
              placeholder="Please specify."
              className={styles.otherTextInput}
              rows={1}
              style={{ minHeight: "34px", resize: "none", overflow: "hidden" }}
            />
          </div>
        )}
      </div>
    </Card>
  );
};

export default MedicalConcernsSection;

